import { Checkbox, Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from 'Components/Worksheets/QestIds';
import { valueOrDefault } from 'Lib/Any';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';

const qestIds = [ids.oversizeDetermination.BS_1377_2_Clause_9_2];

let MeasuredOversizeDeterminationWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const noOversizeMaterial: boolean = useSelector(
    pipe(createWorksheetSelector!('NoOversizeMaterial'), valueOrDefault(false))
  );

  const sieveRecordProps: Array<{
    caption?: string;
    sieveSizeQueryParams?: { SieveSize: string };
  }> = useSelector(
    combine([createWorksheetSelector!('Sieves'), createWorksheetSelector!('AllSieves')], (s, sieveData) =>
      s
        .map((s: any) => sieveData.find((d: any) => d.Id === s.SieveId))
        .map((sd: any) => ({
          caption: sd?.Caption,
          sieveSizeQueryParams: { SieveSize: `${sd?.Size.value} ${sd?.Size.uom}` },
        }))
    ),
    deepEquals
  );

  const sieveMassType = useSelector(createWorksheetSelector!('SieveMassType'));

  const sieveMassTypeOptions: Array<{ label: string; value: string }> = [
    { label: 'Individual Fractions', value: 'individual' },
    { label: 'Cumulative Fractions', value: 'cumulative' },
  ];

  return (
    <>
      <ListFieldSection>
        <Field input={<Checkbox />} name="NoOversizeMaterial" />
      </ListFieldSection>

      <ListFieldSection heading="Oversize Material (> 37.5mm)">
        <Field input={<RadioGroup />} name="SieveMassType" options={sieveMassTypeOptions} />
      </ListFieldSection>

      <WorksheetGridFieldSection name="Sieves">
        <WorksheetRecordGrid
          name={'Sieves'}
          orientation={'vertical'}
          tabDirection={'horizontal'}
          recordProps={{
            headingLabel: 'Sieve Size',
            heading: (i) => sieveRecordProps[i]?.caption,
            preventRemove: true,
            preventCreate: true,
          }}
          fieldSet={[
            {
              name: 'Sieve',
              component: (i) => (
                <Field
                  input={<WorksheetEquipmentDropdown />}
                  equipmentType="sieve"
                  queryParams={sieveRecordProps[i]?.sieveSizeQueryParams}
                />
              ),
              width: 200,
              hidden: noOversizeMaterial,
            },
            {
              name: 'TareMass',
              component: (i) => <Field input={<NumericInput />} />,
              width: 150,
              hidden: noOversizeMaterial,
            },
            {
              name: 'TarePlusWetMassRetained',
              component: (i) => <Field input={<NumericInput />} />,
              width: 150,
              hidden: noOversizeMaterial,
            },
            {
              name: 'WetMassRetained',
              component: (i) => <Field input={<TextOutput />} />,
              width: 150,
              hidden: noOversizeMaterial,
            },
            {
              name: 'WetMassRetainedPercent',
              component: (i) => <Field input={<TextOutput />} />,
              label: `${sieveMassType === 'cumulative' ? 'Cumulatively' : 'Individually'} Retained (%)`,
              width: 150,
            },
          ]}
        />
      </WorksheetGridFieldSection>
    </>
  );
};

MeasuredOversizeDeterminationWorksheet = withInjectedProps(MeasuredOversizeDeterminationWorksheet);

MeasuredOversizeDeterminationWorksheet.qestIds = qestIds;

export default MeasuredOversizeDeterminationWorksheet;
export { MeasuredOversizeDeterminationWorksheet };
